import { render, staticRenderFns } from "./DelegateInformation.vue?vue&type=template&id=150aebf6&scoped=true&"
import script from "./DelegateInformation.vue?vue&type=script&lang=js&"
export * from "./DelegateInformation.vue?vue&type=script&lang=js&"
import style0 from "./DelegateInformation.vue?vue&type=style&index=0&id=150aebf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150aebf6",
  null
  
)

export default component.exports